export default __webpack_public_path__ + "65cd056c9eaa683516f82ec3176469e4.svg";